import {UseEvent} from "./index";
const UseNavBar = (callback) =>{
    let ref=null;
    let backRef=null;
    let menuRef=null;
    let transitionMode = "standart";
    let contentRef=null;
    let firstTouch = 0;
    let width = 0;
    let enable=false;
    let enableLeftSwipe=true;
    let direction=null;
    let clientWidth = window.innerWidth * 0.8;
    const navBarListener=UseEvent();
    const Open = ()=>{
        navBarListener.emit("navBar",true)
    }
    const Close = ()=>{
        navBarListener.emit("navBar",false)
    }
    const toggle = (status)=>{

        width=status?clientWidth:0;
        ref.style.width= width+"px";
        ref.style.transition="0.2s "
        updateWidth()
    }
    const addListener =({navRef,backdropRef,navContentRef,menuRef,mode="standard"})=>{
        transitionMode=mode;
        ref=navRef?.current;
        backRef=backdropRef?.current;
        menuRef=menuRef?.current;
        contentRef=navContentRef?.current;
        document.addEventListener('touchstart',(evt)=>{
             firstTouch = (evt.touches || evt.originalEvent.touches)[0].clientX
             enable=(width===clientWidth)? true: firstTouch<clientWidth*0;
             if(menuRef.contains(evt.target)){
                 enable = firstTouch > clientWidth * 0.85;
             }
             ref.style.transition="unset"
             if(width===clientWidth){
                 enableLeftSwipe=false;
             }
        })
        document.addEventListener("touchmove", function(evt) {
            if(enable){
                const translateX  = (evt.touches || evt.originalEvent.touches)[0].clientX;
                direction=firstTouch<translateX?'right':'left';
                if(direction==="right" && enableLeftSwipe){
                    let tmp = translateX-firstTouch;
                    width= tmp>clientWidth?clientWidth:tmp
                    updateWidth(false);
                }else{
                    let tmp = clientWidth-(firstTouch-translateX);
                    width=tmp<0?0:tmp>clientWidth?clientWidth:tmp;
                    updateWidth(false);
                }
            }
        }, false);
        document.addEventListener("touchend", function({touches}) {
           if(width!==clientWidth){
               width=width<clientWidth/0.75?0:clientWidth;
               enableLeftSwipe=true;
               updateWidth();
               enable=false;
           }

        }, false);
    }
    const updateWidth = (transition=true)=>{
        contentRef.style.left=-(clientWidth - width)+"px"
        ref.style.width=width+"px";
        contentRef.style.transition=!transition?'unset':"0.3s";
        ref.style.transition=!transition?'unset':"0.3s";
        let percent =width/clientWidth;
        let opacity = 0.5 * percent;
        let opacityNav =  percent;
        if(transitionMode==="fade"){
            ref.style.opacity=transition && width===0?0:opacityNav;
        }
       /* if(document.getElementById("cuki-deda")){
            //document.body.style.overflow=(width===0? 'auto':'hidden');
            console.log(width)
           document.getElementsByTagName('html')[0].style.overflow = (width===0? 'auto':'hidden')
        }*/
       backRef.style.width=transition && width===0?0 :"100vw"
       backRef.style.height=transition && width===0?0:"100vh"
       backRef.style.zIndex=transition && width===0?-1:1050
       backRef.style.opacity=transition && width ===0?  0: opacity
        callback(width)
    }
    const unsubscribe = () =>{
        document.removeEventListener("touchstart",e=>console.log("remove touch listener"))
        document.removeEventListener("touchmove",e=>console.log("remove touchmove listener"))
        document.removeEventListener("touchend",e=>console.log("remove touchend listener"))

    }
    return {navBarListener,Open,Close,addListener,toggle,unsubscribe,clientWidth}
}
export default UseNavBar;
